export class User {
  constructor(data = {}) {
    this.id = data.id ?? null;
    this.name = data.name ?? '';
    this.email = data.email ?? '';
    this.avatar = data.avatar ?? null;
    this.role = data.role ?? 'agent';
    this.permissions = data.permissions ?? [];
    this.online = data.online ?? true;
    this.mustChangePassword = data.mustChangePassword ?? false;
  }

  hasPermission(permission) {
    if (!permission) return true;
    return this.permissions.includes(permission);
  }
}

export default User;
